import { apiGet, CRM_API_URI } from "./index";

const account = {
  PopulateOptions: async (clientId: number) => {
    const data = await apiGet(`${CRM_API_URI}/api/agreement/dropdowns/populate/short/${clientId}`);
    return data;
  },
};

export default account;
